import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroLineItemsSection', {
    colNameItem: 'Item',
    colNameDescription: 'Description',
    colNameQty: 'Qty',
    colNameUnitPrice: 'Unit price',
    colNameDiscount: 'Disc %',
    colNameDiscountInvoice: 'Disc ⓘ',
    colTitleDiscountInvoice:
        'Discounts can be entered as a numeric value or a percentage. Include the % symbol for a percentage discount.',
    colNameTaxAmount: 'Tax Amount',
    colNameAccount: 'Account',
    colNameTaxRate: 'Tax rate',
    colNameAmount: 'Amount',
    cellPlaceholderItem: 'Choose item',
    cellPlaceholderDescription: 'Enter description',
    cellPlaceholderQty: 'Enter value',
    cellPlaceholderUnitPrice: 'Enter value',
    cellPlaceholderDiscount: 'Enter value',
    cellPlaceholderTaxAmount: 'Enter value',
    cellPlaceholderAccount: 'Choose account',
    cellPlaceholderTaxRate: 'Choose tax',
    cellPlaceholderTrackingCategory: 'Choose {categoryName}',
    headerText: 'Line items',
    lineAmountTypeLabel: 'Amounts are',
    differentAmountWarningDescription: '{templateName} line amount differs from File line amount.',
    differentAmountWarningLabel1: '{templateName} line amount:',
    differentAmountWarningLabel2: 'File line amount:',
    differentTaxAmountWarningDescription: '{templateName} line tax amount differs from File line tax amount.',
    differentTaxAmountWarningLabel1: '{templateName} line tax amount:',
    differentTaxAmountWarningLabel2: 'File line tax amount: ',
    multipleAccountsWarning:
        '{contactDisplayName} {requestName} had multiple accounts in the past. Check suggested accounts.',
    multipleTaxCodesWarning:
        '{contactDisplayName} {requestName} had multiple tax rates in the past. Check suggested tax rate.',
    multipleTrackingCategoriesWarning:
        '{contactDisplayName} {requestName} had multiple {categoryName} in the past. Check suggested {categoryName}.',
    differentCurrencyWarningDescription: '{templateName} currency differs from File currency.',
    differentCurrencyWarningLabel1: '{templateName} currency:',
    differentCurrencyWarningLabel2: 'File currency:',
    nonExistCurrencyWarning: '{templateName} currency doesn’t exist in Xero',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
